const getList = state => state.accounts
const getSearchData = state => state.searchData
const getListPending = state => state.pending
const getAccountData = state => state.accountData
const getPagination = state => state.pagination
const getSearchPagination = state => state.searchPagination
const isSearchDataExist = state => state.searchDataExist

export default {
  getList,
  getListPending,
  getSearchData,
  getAccountData,
  getSearchPagination,
  getPagination,
  isSearchDataExist
}



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js